import React from 'react'
import { Snackbar, IconButton, Grid, makeStyles } from '@material-ui/core';
import styles from "./styles"
import CloseIcon from '@material-ui/icons/Cancel';
import InfoIcon from '@material-ui/icons/Info';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';

function CookiePreviewBanner(props) {
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  const {
    handleClose,
    vertical,
    horizontal,
    open,
    root,
    content,
  } = props

  return (
    <div>
      <Snackbar
        classes={{
          root,
        }}
        open={open}
        anchorOrigin={{ vertical, horizontal }}
      >
        <Grid container>
          <Grid item md={1}>
            <IconButton className={classes.infoButton} color="inherit">
              <InfoIcon className={classes.iconInfo} />
            </IconButton>
          </Grid>
          <Grid item md={10} className={classes.messageContainer} id='cookie-banner-content'>
            {parse(content)}
          </Grid>
          <Grid item md={1}>
            <IconButton className={classes.closeButton} id='cookie-banner-close-button' data-apim-test='cookie-banner-close-button' color="inherit" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Snackbar>
    </div>
  )
}

CookiePreviewBanner.propTypes = {
  handleClose: PropTypes.func,
  vertical: PropTypes.string,
  horizontal: PropTypes.string,
  open: PropTypes.bool,
  root: PropTypes.string,
  content: PropTypes.string,
}

export default CookiePreviewBanner;
